import MonsterButton from '../../MonsterButton';

import { useStore } from '@tanstack/react-form';
import { useFormContext } from '.';

interface Props {
  colorSwap?: boolean;
  text?: string;
  submittingText?: string;
}

export function MonsterSubmitButton({ colorSwap, text = 'Submit', submittingText = 'Submitting...' }: Props) {
  const form = useFormContext();

  const [isSubmitting, canSubmit] = useStore(form.store, (state) => [state.isSubmitting, state.canSubmit]);

  function errorClick() {
    const fieldErrors = form.getAllErrors();
    const errors = fieldErrors.form.errorMap.onChange;

    const allErrorMessages = Object.values(errors)
      .filter(
        (field): field is Array<{ message: string }> =>
          field !== null && typeof field === 'object' && Array.isArray(field) && field.length > 0
      )
      .map((field) => field[0].message);

    if (allErrorMessages.length > 0) {
      alert(allErrorMessages.join('\n\n'));
    }
  }

  if (!canSubmit) {
    return (
      <MonsterButton type='button' onClick={() => errorClick()}>
        {isSubmitting ? submittingText : text}
      </MonsterButton>
    );
  }

  return (
    <MonsterButton colorSwap={colorSwap} type='submit' disabled={isSubmitting || !canSubmit}>
      {isSubmitting ? submittingText : text}
    </MonsterButton>
  );
}
